module.exports = __webpack_public_path__ + "media/control_acceso/barrera_automatica-f4590efd.png";